<template >
<div>


 <div class="modal" id="staticBackdropWaiting" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    
    <div class="modal-content border-warning">
      <div class="modal-header bg-info text-white">
        <h5 class="modal-title" id="staticBackdropLabel">
          <i style="color:black" :class="{rotate : rotate}"  class="far fa-hourglass mr-3"></i>
          <strong>{{ props.msg1 }}</strong></h5>     
      </div>
      
      <div class="modal-body">
        <div v-if="!btn">
          <spinner class="text-center_" v-bind:spinner='spinner'></spinner>
          <p id="base-timer-label" class="text-center mt-4">
          <!-- Remaining time label -->
          <h4 class="text-center">
            TEMPO MASSIMO DI ATTESA  <strong> {{ time_limit }} </strong> SECONDI.
          </h4>
          <div class="text-center">
            <span>
              <span class="mr-2 ">Min.</span>
                <span class="border border-secondary"><strong class="time" style="color:blue;">{{ formatTimeLeft(timeLeft).timeDisplay.mm }} </strong> </span>
            </span> 
            <span class="ml-3 mr-3"></span>
            <span>
              <span class="mr-2">Sec.</span>  
                <span class="border border-secondary"><strong class="time" style="color:blue;"> {{ formatTimeLeft(timeLeft).timeDisplay.ss }}</strong></span>
            </span> 
          
          </div>          
          </p>
        </div>  
        <div v-else class="text-center mt-4">
          <h4 style="color:red">            
            ATTENZIONE TEMPO MASSIMO DI ELABORAZIONE SCADUTO.            
          </h4>
          <h4>
            <p>
              {{ props.msg2 }}
            </p>
          </h4>
        </div>          
      </div>
      <div class="modal-footer">        
        <button @click="closeModal()" v-if="btn" type="button" class="btn btn-primary">
          <i style="color:white" class="fas fa-door-closed mr-3"></i>
            CHIUDI            
          </button>
        
      </div>
      
    </div>
    
  </div>
</div>

</div>
</template>
<script>

import spinner                    from '@/components/common/Spinner.vue';
import { mapGetters }             from 'vuex'

export default {
  props      : ['props'],
  components : {spinner},
  
 data () {
    return {
    
    intervalId : 0,  
    btn        : false,  
    time_limit : 0,  
    timePassed : 0,
    timeLeft   : 0,
    spinner    : true,
    rotate     : false
      
    }
  },
  computed: 
  {
   ...mapGetters(['timeout'])
  }  ,   
  watch: {
    'props.sentinel': function (newVal){
      if(newVal == 1 || newVal == 3)
            {
              

              clearInterval(this.intervalId)
              $('#staticBackdropWaiting').modal('hide')
              this.$nextTick(()  => {              
                this.$emit('close')
              })

            }
            else if(newVal == 2)
            {
              /* NETWORK ERROR */
              clearInterval(this.intervalId)  
              this.btn = true
                            
            }
      

    }

    
     
  },


mounted()
{
  const timeout = this.timeout
  this.time_limit = timeout / 1000
  this.timeLeft   = timeout / 1000
},  
created()
{   
  this.$nextTick(()  => {                  
    $('#staticBackdropWaiting').modal('show')
    
    this.startTimer()   
    
    })  
},
methods :{

closeModal()
{
  $('#staticBackdropWaiting').modal('hide')
  this.$nextTick(()  => {              
      this.$emit('close')        
    })    
}, 

formatTimeLeft(time)
{

  // The largest round integer less than or equal to the result of time divided being by 60.
  const minutes = Math.floor(time / 60);
  
  // Seconds are the remainder of the time divided by 60 (modulus operator)
  let seconds = time % 60;
  
  // If the value of seconds is less than 10, then display seconds with a leading zero
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  
  let timeDisplay = {}
  timeDisplay = {'mm':minutes,'ss':seconds}
  // The output in MM:SS format
  //return `${minutes} : ${seconds}`;
  return {timeDisplay}  
 
},  
startTimer() {
  this.intervalId = setInterval(() => {
    
    // The amount of time passed increments by one
    this.timePassed = this.timePassed += 1;
    this.timeLeft = this.time_limit - this.timePassed;
    
    // The time left label is updated
    this.formatTimeLeft(this.timeLeft)
  }, 1000);
},




}

}

</script>
<style scoped>

.rotate {
  animation: rotation 8s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}




h4 {
  color       : black;
}
p {
  font-family : "Roboto Condensed";
  font-size   : 20px;
  font-weight : bold;
}
span {
  font-family : "Roboto Condensed";
  font-size   : 20px;
  font-weight : bold;
}
.time {
  font-size   : 24px !important;
  
  padding:  15px;
  
}

</style>
